import {
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  ATTRS_DESCRIPTION,
  ATTRS_RESULT,
  SpanName,
} from 'core/common/observability/entities';
import { flushSpans } from 'core/common/observability/utils/flushSpans';
import { AppThunk } from 'core/common/store';
import { copyToClipboard } from 'core/common/utils/copyToClipboard';
import { Web2AppLinkCopyResult } from 'core/user/entities';
import { getWeb2AppLinkType } from 'core/user/utils/getWeb2AppLinkType';
import { getAppLinkLoadingStatus } from '../selectors';

export const copyWeb2AppLink =
  (link: string): AppThunk<Promise<void>> =>
  async (_, getState, context) => {
    const { observabilitySystem, funnelSettingsService, appEnvironment } = context;

    const linkStatus = getAppLinkLoadingStatus(getState());

    const spanAttributes = {
      [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
      [ATTRS_ANALYTICS_FLOW_NAME]: funnelSettingsService.getFlowName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      [ATTRS_DESCRIPTION]: appEnvironment.getPlatform(),
    };

    const span = observabilitySystem.startSpan(SpanName.WEB2APP_LINK_COPIED);
    span.setAttributes(spanAttributes);
    span.setType(getWeb2AppLinkType(linkStatus));

    const failReason = await copyToClipboard(link);
    const result = failReason ? Web2AppLinkCopyResult.FAIL : Web2AppLinkCopyResult.SUCCESS;

    span.setAttribute(ATTRS_RESULT, result);

    if (failReason) {
      span.setReason(failReason);
      span.fail(failReason);

      await flushSpans(observabilitySystem);

      return;
    }

    span.succeed();

    await flushSpans(observabilitySystem);
  };
